import React from "react";
import SheetRecordsTable from "../../components/ui-custom/SheetRecordsTable";

// Invoices for the logged-in customer/vendor (from Google Sheet "Invoices").
const Invoices = () => <SheetRecordsTable endpoint="/portal/invoices" />;

export default Invoices;
